import { Link } from "react-router-dom";
import { formatDate } from "../../utils/dateUtils";

function SearchListItem({ item }) {
  const moduleName = item.board_module_name || item.module_name || "";
  const link = moduleName ? `/bbs/${moduleName}/${item.document_id}` : `/bbs/${item.document_id}`;

  return (
    <Link
      to={link}
      className="group flex flex-col gap-3 rounded-2xl border border-white/10 bg-ink-900/70 px-5 py-4 transition hover:border-brand-400/50 hover:bg-ink-900"
    >
      <div className="flex flex-wrap items-center gap-2 text-xs text-ink-200">
        {item.category_name && <span className="chip">{item.category_name}</span>}
        <span className="pill">#{item.document_id}</span>
        <span className="pill">{formatDate(item.created_at)}</span>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-white transition group-hover:text-brand-200">
            {item.title}
          </h3>
          <p className="mt-1 text-xs text-ink-200">{item.author_nickname}</p>
        </div>
        <div className="flex flex-wrap items-center gap-3 text-xs text-ink-200">
          <span className="pill">댓글 {item.comment_count ?? 0}</span>
          <span className="pill">조회 {item.view_count}</span>
        </div>
      </div>
    </Link>
  );
}

export default SearchListItem;
